module.exports = __webpack_public_path__ + "static/media/ipnos-scenario-5.66d91584.png";